module.exports = __webpack_public_path__ + "static/media/bullet_icon.81547ec9.svg";